export default function Ferramentas() {
  const ferramentas = [
    {
      titulo: 'Radar de sinais',
      descricao: 'Aprenda a perceber quando uma crise está começando.'
    },
    {
      titulo: 'Registro de gatilhos',
      descricao: 'Descubra padrões que provocam crises.'
    },
    {
      titulo: 'Protocolos por situação',
      descricao: 'Saiba exatamente o que fazer em momentos difíceis.'
    },
    {
      titulo: 'Micro-passos de condução',
      descricao: 'Transforme tarefas difíceis em etapas simples.'
    }
  ];

  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">

        {/* Eyebrow */}
        <p className="text-center text-xs sm:text-sm font-semibold tracking-widest text-teal-600 uppercase mb-3 sm:mb-4">
          Ferramentas do método
        </p>

        {/* Título */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-10 sm:mb-14 leading-tight">
          Ferramentas simples para aplicar no dia a dia
        </h2>

        {/* Cards */}
        <div className="grid sm:grid-cols-2 gap-5 sm:gap-6">
          {ferramentas.map((item, index) => (
            <div
              key={index}
              className="flex gap-4 bg-teal-50/60 border border-teal-100 rounded-xl px-6 py-5 hover:border-teal-300 transition-colors duration-200"
            >
              {/* Ícone cérebro */}
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-teal-600 rounded-lg mt-0.5">
                <i className="ri-brain-line text-white text-lg"></i>
              </div>
              <div>
                <h3 className="text-gray-900 font-semibold text-base sm:text-lg mb-1 leading-snug">
                  {item.titulo}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  {item.descricao}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
